import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useRouter } from '../../hooks/useRouter.js';
import { projectSettings } from '../../ProjectSettings.js';
import { adjustHref } from '../../utils/adjustHref.js';
import { isOnlyDigits } from '../../utils/isOnlyDigits.js';
import { style } from '../../utils/style.js';
import { joinPath } from '../../utils/url.js';
const svgUseStyleMap = {
    '': '',
    normal: '',
    color: 'text-primary-main',
    black: 'text-black',
    white: 'text-black',
    gray: 'text-gray',
};
export const Icon = JSX(({ className = '', imageClassName = '', name = '', alt = `Иконка ${name}`, title = alt, iconVersion = 'color', width, height, }) => {
    const router = useRouter();
    const iconName = iconVersion === 'normal' ? `${name}.svg` : `sprites.svg#${name}`;
    const href = adjustHref(router)(joinPath(projectSettings.CDN, '/icons/', iconName));
    if (iconVersion === 'normal') {
        // fix svg gradient color
        return (_jsx("img", { className: className, src: href, alt: alt, title: title, "aria-hidden": "true", width: width, height: height, style: getInlineStyle(className, height) }));
    }
    return (_jsx(Background, { className: className, children: _jsxs("svg", { className: style(getSvgSize(width), svgUseStyleMap[iconVersion], {
                invert: iconVersion === 'white',
            }, imageClassName), width: width, height: height, "aria-hidden": "true", children: [title ? _jsx("title", { children: title }) : null, alt ? _jsx("desc", { children: alt }) : null, _jsx("use", { href: href, xlinkHref: href })] }) }));
});
const getInlineStyle = (className, height) => {
    if (className?.includes('h-')) {
        return {};
    }
    return { height: isOnlyDigits(height) ? `${height}px` : height, width: 'auto' };
};
const getSvgSize = (width) => (width ? '' : 'w-full h-full');
const Background = JSX(({ className, children }) => className ? (_jsx("div", { role: "img", className: className, children: children })) : (children));
//# sourceMappingURL=Icon.js.map